import { UserPreferencesSaveRequest } from "@/main/models/request/userPreferencesRequest";
import { UserTypes, UserActionTypes } from "./userTypes";
import { UserResponse } from "@models/response/userResponse";

export function userSignIn(email: string, password: string): UserActionTypes {
	return {
		type: UserTypes.USER_SIGNIN,
		payload: { email, password },
	};
}

export function userSetCurrent(currentUser: UserResponse | null): UserActionTypes {
	return {
		type: UserTypes.USER_SET_CURRENT,
		payload: currentUser,
	};
}

export function getUserPreferences() {
	return {
		type: UserTypes.GET_USER_PREFERENCES,
	};
}

export function saveUserPreferences(
	preferences: UserPreferencesSaveRequest | null,
	isError: boolean = false,
	errorMessages: string[] | null = null,
): UserActionTypes {
	return {
		type: UserTypes.SAVE_USER_PREFERENCES,
		payload: { preferences, isError, errorMessages },
	};
}

export function userOpenModalUserChangePasswordAlert(
	open: boolean,
	numberOfDaysToPasswordExpires: number | null = null,
): UserActionTypes {
	return {
		type: UserTypes.USER_OPEN_MODALUSER_CHANGEPASSWORD_ALERT,
		payload: { open, numberOfDaysToPasswordExpires },
	};
}
